module.exports = __webpack_public_path__ + "img/02.c7f7dbc9.png";